<template>
  <div class="package-type-switch">
    <button
      v-for="package_type_option in available_package_type_options"
      :key="package_type_option.value"
      :class="`package-type-switch--button ${
        package_type_option.value === package_type ? 'active' : ''
      }`"
      @click="() => select_package_type(package_type_option.value)"
    >
      {{ package_type_option.label }}
    </button>
  </div>
</template>

<script>
import { PACKAGE_TYPES } from "@alpitour/resources"; 
import { alpitour_rybbit_event } from "@alpitour/utilities/rybbit";
import { are_services_present } from "@/services";

const only_stay_package_services = [
  "keyds",
  "keydsMap",
  "search",
  "details",
  "quote", 
].map(base => `sololand.${base}`)

export default {
  name: "package-type-switch",
  props: {},
  data() {
    return {
      package_type_options: [
        {
          label: "Volo + Hotel",
          value: PACKAGE_TYPES.FLIGHT_AND_STAY,
        },
        {
          label: "Solo Hotel",
          value: PACKAGE_TYPES.ONLY_STAY,
        },
      ],
    };
  },
  mounted() {
    const allowed_package_types = this.get_allowed_package_types().reduce(
      (map, key) => {
        map[key] = true;
        return map;
      },
      {},
    );
    this.package_type_options = this.package_type_options.filter(
      (option) => allowed_package_types[option.value],
    );
    if (!allowed_package_types[this.package_type]) {
      this.package_type = this.package_type_options[0].value;
    }
  },
  computed: {
    package_type: {
      get() {
        return this.$store.state.liveat.package_type;
      },
      set(value) {
        this.$store.commit("liveat/package_type", value);
      },
    },
    available_package_type_options() {
      if (this.$route.name === "homepage") {
        return this.package_type_options;
      }
      return this.package_type_options.filter(
        ({ value }) => value === this.package_type,
      );
    },
  },
  methods: {
    select_package_type(value) {
      if (this.package_type === value) {
        return;
      }
      this.package_type = value;
      this.$emit("change:package_type", value);
      alpitour_rybbit_event("package:type:select", {
        selected_type: value,
      });
    },
    get_allowed_package_types() {
      const allowed_package_types = [PACKAGE_TYPES.FLIGHT_AND_STAY]
      // If endpoints for the only-stay flow are present enable it
      if (are_services_present(only_stay_package_services)) {
        allowed_package_types.push(PACKAGE_TYPES.ONLY_STAY);
      }
      return allowed_package_types;
    },
  },
};
</script>

<style lang="scss" scoped>
.package-type-switch {
  display: flex;
  gap: $grid-gutter-width / 4;
  &--button {
    background: $white;
    border-radius: $border-radius-lg * 2;
    border: 1px solid $gray-200;
    padding: ($grid-gutter-width / 6) ($grid-gutter-width / 2);
    color: $gray-600;
    font-size: $font-size-md;
    font-weight: $vb-font-weight-semibold;
    transition-duration: 300ms;

    &:hover {
      color: var(--info);
    }

    &.active {
      color: var(--primary);
    }
  }
}
</style>
